import React, { useMemo } from "react";
import { groupBy, uniqBy } from "lodash";
import { useSelector } from "react-redux";

/**
 * Use Combine Branches and Locations  Hook
 */
export default () => {
  const { branches, locations, branchLocations } = useSelector(
    (state) => state
  );
  return useMemo(() => {
    /** Group branches */
    const byBranch = groupBy(branchLocations.data, "branch");
    return branches.data.map(({ id, name }) => {
      const branch = {
        locations: [],
        branchName: name,
        branchId: id,
      };
      /**  Map locations for each  branch */
      uniqBy(byBranch[id], "location").forEach(({ location }) => {
        const index = locations.byId[location];
        if (index != null) {
          branch.locationId = locations.data[index].id;
          branch.locations.push(locations.data[index]);
        }
      });
      return branch;
    });
  }, [branches, branchLocations, locations]);
};
